import { createFileRoute, redirect } from "@tanstack/react-router";
import type { RouterContextWithSession } from "../../../router";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";
import Workflows from "@/pages/Admin/Workflows";

export const Route = createFileRoute("/_admin/workflows/")({
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  loader: async ({ context }) => {
    if (typeof window === "undefined") return;
    const { session } = context as RouterContextWithSession;
    if (!session) return;
  },
  pendingComponent: () => <PageSkeleton rows={4} variant="cards" />,
  errorComponent: createRouteError("Outbound Webhooks"),
  component: Workflows,
});
